'use client';

import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { getSettings } from '@/lib/actions/settings';
import { getPeople } from '@/lib/actions/people';
import { useTranslations, useLocale } from '@/i18n/intl';
import AboutUsClient from './AboutUsClient';

export default function AboutUsPage() {
  const t = useTranslations('About');
  const locale = useLocale();
  const [settings, setSettings] = useState<Record<string, string>>({});
  const [people, setPeople] = useState<any[]>([]);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const keys = [
      'about_hero_image',
      'about_headline',
      'about_description',
      'about_vision',
      'about_mission',
      'about_why_simisi',
      'about_overview',
      'about_values',
      'about_stats',
      'home_stats',
    ];

    void Promise.all([getSettings(keys), getPeople()]).then(([s, p]) => {
      setSettings(s);
      setPeople(p);
      setReady(true);
    });
  }, []);

  if (!ready) return null;

  return (
    <>
      <Helmet>
        <title>{t('title')}</title>
        <meta name="description" content={t('headline')} />
      </Helmet>
      <AboutUsClient
        settings={settings}
        people={people}
        locale={locale}
      />
    </>
  );
}
